import { gql } from "@apollo/client";

export const GET_AUTO_RENEWAL_USER_PREFERENCES = gql`
  query GetUserAutoRenewalPreferences {
    getAutoRenewalUserPreferences {
      success
      messages
      preferences {
        contactId
        animalId
        schemaName
        currentSubscriptionId
        newSubscriptionId
        newPlanName
        newPlanId
        cardId
        cardDetails {
          cardId
          last4Digits
          cardBrand
          expMonth
          expYear
        }
        newPlanType
        newPlanStartDate
        squareCustomerId
        renewalStatus
        newPlanEnrollmentFee
        newPlanSubscriptionFee
        paymentMethodProvider
        scratchpayPlanId
      }
    }
  }
`;

export const GET_AUTO_RENEWAL_PREFERENCE = gql`
  query GetAutoRenewalPreference($currentSubscriptionId: String!) {
    getAutoRenewalPreferences(currentSubscriptionId: $currentSubscriptionId) {
      success
      messages
      preference {
        contactId
        animalId
        schemaName
        currentSubscriptionId
        newSubscriptionId
        newPlanName
        newPlanId
        cardId
        cardDetails {
          cardId
          last4Digits
          cardBrand
          expMonth
          expYear
        }
        newPlanType
        newPlanStartDate
        squareCustomerId
        renewalStatus
        newPlanEnrollmentFee
        newPlanSubscriptionFee
        paymentMethodProvider
        scratchpayPlanId
      }
    }
  }
`;

